<script>
export default {
  mounted () {
    this.$cookie.delete('session_id')
    this.$router.push('login')
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/Logout.vue